import { Loader } from "@design-system/components";
import { cn } from "@design-system/utils";
import React from "react";

interface FullPageLoaderProps {
  className?: string;
}

function FullPageLoader({ className }: FullPageLoaderProps) {
  return (
    <div
      className={cn(
        "bg-background flex min-h-screen items-center justify-center",
        className
      )}
    >
      <Loader size={40} aria-label="Loading application" />
    </div>
  );
}

export { FullPageLoader };
